module.exports = __webpack_public_path__ + "img/Butterfly_00030.04209ef3.png";